module.exports = "/_next/static/images/reliableSolutions-05a5056d7ce10240c93a591486bb3404.png.webp";